import styles from './FJMobileImageItem.module.less';
import classNames from 'classnames';
import FJResourceItemLoading from '../../../common/components/FJResourceItemLoading/FJResourceItemLoading';
import FJLocalStore from '../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import FJImage from '../../../common/components/FJImage/FJImage';
import FJCheckBox from '../../../common/components/FJCheckBox/FJCheckBox';
import FJUtil from '../../../util/FJUtil';

const FJMobileImageItem = props => {
    const { item, selected = false, isShowSelected = false, onSelected, reGenerate, onPreview } = props;
    const { id, imgUrl, isLoading, isReload } = item;
    const _onPreview = e => {
        e.stopPropagation();
        if (isShowSelected) {
            onSelected(id, !selected);
            return;
        }
        if (isLoading || isReload) return;
        onPreview(item);
    };
    const _onSelected = (bool, e) => {
        e.stopPropagation();
        onSelected && onSelected(id, bool, e);
    };
    const _reGenerate = e => {
        FJUtil.forbidEvent(e);
        reGenerate && reGenerate(id);
    };
    const _renderRetry = () => {
        return (
            <div className={styles.retry_box}>
                <div className={styles.retry_btn} onClick={_reGenerate}>
                    {FJLocalStore._('retry')}
                </div>
            </div>
        );
    };
    const _renderMain = () => {
        return (
            <>
                <FJImage imgSrc={imgUrl} />
                <FJCheckBox className={styles.check_box} selected={selected} type='circle' dataChange={_onSelected} />
            </>
        );
    };
    const _render = () => {
        if (isReload) {
            return _renderRetry();
        } else if (isLoading) {
            return <FJResourceItemLoading className={styles.loading} />;
        } else {
            return _renderMain();
        }
    };
    return (
        <div className={classNames(styles.img_box, isShowSelected ? styles.selected : '')} onClick={_onPreview}>
            {_render()}
        </div>
    );
};
FJMobileImageItem.propTypes = {
    item: PropTypes.object,
    selected: PropTypes.bool,
    isShowSelected: PropTypes.bool,
    onSelected: PropTypes.func,
    onDelete: PropTypes.func,
    onDownload: PropTypes.func,
    reGenerate: PropTypes.func,
    onPreview: PropTypes.func,
    hideSelect: PropTypes.bool,
    hideDelete: PropTypes.bool,
    hideCompare: PropTypes.bool,
    hideDownload: PropTypes.bool,
    onEdit: PropTypes.func,
    hideEdit: PropTypes.bool,
};
export default FJMobileImageItem;
